import React, { FunctionComponent } from 'react';
import Modal from 'react-modal';
import ReactPlayer from 'react-player';

import style from './ParallelLabVideo.module.less';
import game from './assets/device.png';

export const ParallelLabVideo: FunctionComponent = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const openModal = (ev) => {
    ev.preventDefault();
    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <img className={style.device} onClick={openModal} src={game} alt="Device" />
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 1005
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '0'
          }
        }}
        contentLabel="Example Modal"
      >
        <div className={style.modalContent}>
          <ReactPlayer
            url="https://youtu.be/FEzDT7Ke_WI"
            playing={true}
            width="100%"
            height="100%"
            controls={true}
          />
        </div>
      </Modal>
    </>
  );
};

// // <button className={style.close} type="button" onClick={closeModal}>X</button>